// The office shell's pages (each rail page is an iframe loaded the first time it opens), and the
// signed-in user: checkAuthState, getCurrentUserData, logoutUser.
// Moved out of app.js unchanged (docs/split-plan.md, session 7).
import { auth } from './initFirebase';
import { selectHubTab } from './railHubs';
import { getUserRole } from './utilities';
import { onAuthStateChanged, signOut } from 'firebase/auth';

/* ⇢  exact ids from the DOM  */
const PAGE_PATHS = {
  dashboard       : '/dashboard',
  haulLaunch      : '/haulLaunch',
  scheduler       : '/scheduler',
  maintenance     : '/maintenance',
  compliance      : '/compliance',
  battery         : '/battery',
  equipment       : '/equipment',
  slips           : '/slips',
  timeclock       : '/timeclock',
  dockSchedule    : '/dockSchedule.html',
  uscg            : '/uscg.html',
  requests        : '/requests',
  reports         : '/reports',
  drystack        : '/drystack',
  messages        : '/messages',
  techQuestions   : '/techQuestions',
  help            : '/help',
  maps            : '/maps',
  customers       : '/customers',
  mooringDatabase : '/mooringDatabase',
  rentalDatabase  : '/rentalDatabase',
  // Hauls and Launches are one crew page (mooringOps), each locked to its season.
  mooringHaul     : '/mooringOps?mode=haul',
  mooringLaunch   : '/mooringOps?mode=launch',
  mooringEstimator: '/mooringEstimator',
  launchDispatch  : '/launchDispatch',
  mooringMapEditor: '/mooringMapEditor',
  mooringFitCheck : '/mooringFitCheck',
  mooringField    : '/mooringField',
  impactForecast  : '/impactForecast',
  inventoryDatabase : '/inventory',
  receivingDatabase : '/receiving',
  'fuel-reading'  : '/fuel',
  'fuel-dashboard': '/fuelDashboard',
  settings        : '/settings',
};


export function loadSecondaryIframesLazy(){
  Object.entries(PAGE_PATHS).forEach(([id,src])=>{
    const host=document.getElementById(id);
    if(host)host.dataset.lazySrc=src;
  });
}
export async function showPage(id) {
  try {
    document.querySelectorAll('.page-view').forEach(el => {
      el.style.display   = el.id === id ? 'flex'   : 'none';
      el.style.visibility = el.id === id ? 'visible' : 'hidden';
    });
    selectHubTab(id);

    const host = document.getElementById(id);
    // lazySrc is only stamped by loadSecondaryIframesLazy() late in start-up; a rail click
    // before that used to build an <iframe src="undefined"> that stayed broken.
    const src = host?.dataset.lazySrc || PAGE_PATHS[id];
    if (host && src && !host.querySelector('iframe')) {
      host.innerHTML = `<iframe src="${src}"
                               class="page-frame"
                               loading="lazy"></iframe>`;

      const iframe = host.querySelector('iframe');
      if (iframe) {
        // Wait until the iframe's first load event
        await new Promise(res => iframe.addEventListener('load', res, { once: true }));
      }
    }
  } catch (error) {
    console.error('Error showing page:', error);
    throw error;               // make sure the Promise rejects on error
  }
}



let checkAuthStatePromise = null;

export function checkAuthState() {
  if (checkAuthStatePromise) return checkAuthStatePromise;

  checkAuthStatePromise = (async () => {
    const user = auth.currentUser;
    if (!user) return null;

    localStorage.setItem('userInfo', JSON.stringify(user));
    localStorage.setItem('currentUserId', user.uid);

    const role = await getUserRole(user.uid);
    if (role) localStorage.setItem('userRole', role);

    return null;
  })();

  return checkAuthStatePromise;
}




export async function getCurrentUserData() {
  try {
    const user = auth.currentUser;
    if (user) {
      const email = user.email;
      return user;
    }
  } catch (error) {
    console.error('Cannot get current user info' + error);
  };
}

export function logoutUser() {
  signOut(auth)
    .then(() => {
      console.log("User signed out");
      location.reload();
    })
    .catch((error) => {
      // An error happened
      console.error("Error signing out: ", error);
    });
}

function displayMessage(title, message) {
  // Display the message to the user (you can customize this function based on your UI)
  alert(`${title}\n${message}`);
}

// The signed-in user, once Firebase has restored the session.
export function waitForAuthUser() {
  if (auth.currentUser) return Promise.resolve(auth.currentUser);
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) { unsub(); resolve(user); }
    });
  });
}
